<template>
	<section>
		<HeaderForm :title="'Tambah Shipment (' + (this.$route.params.type == 'kg' ? 'Kg' : 'Box') + ')'" class="title-form-pengiriman" note="pengiriman"/>
		
		<Form />
	</section>
</template>

<script>
import HeaderForm from '@/components/HeaderForm'
import Form from './components/Form'
export default {
	name: 'DeliveryAdd',
	components: {
		HeaderForm,
		Form
	}
}
</script>